import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map } from "rxjs";
import { UserConfigsActions } from "@store/app.actions";
import { openAiLinkActions } from "./open-ai-link/open-ai-link.actions";

@Injectable()
export class ThirdPartyEffects {

    public init$ = createEffect(() => this.actions$.pipe(
        ofType(UserConfigsActions.authenticated),
        map(() => openAiLinkActions.initialize())
    ));

    constructor(
        private actions$: Actions) { }
}
